var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{},[_c('elNavbar'),_vm._m(0),_c('elFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-light"},[_c('div',{staticClass:"container py-4"},[_c('h1',[_vm._v("How to use site")])])])
}]

export { render, staticRenderFns }